<template>
    <div class="">
        <section class="breadcrumb-section mt_20">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Manage Payment
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="myorder_section pt-0 pb-0 manage_payment">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="dashboard_design d-md-flex mb_82">
                            <div class="side_bar px-0 sidebar_desk">
                                <ul class="side_bar_links mt_2 p-0">
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/myorder.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Orders</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/saved_design.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Saved Designs</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/upload_img.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Uploaded Images</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/payement.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Payment Options</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/fav.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Favorite</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/edit_profile.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Edit Profile</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class="active"
                                            ><img
                                                src="/maincss/images/mystore.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Store</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_payment.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Player</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_team.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Team</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/logout.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Logout</a
                                        >
                                    </li>
                                </ul>
                            </div>
                            <div class="sidebar_mobile">
                                <a class="dropdown-toggle" id="item2" href="#"
                                    >My Account</a
                                >
                                <div class="side_bar px-0">
                                    <ul
                                        id="submenu2"
                                        class="side_bar_links mt_2 p-0 dropdown"
                                    >
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/myorder.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Orders</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/saved_design.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Saved Designs</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/upload_img.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Uploaded Images</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/payement.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Payment Options</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/fav.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Favorite</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/edit_profile.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Edit Profile</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class="active"
                                                ><img
                                                    src="/maincss/images/mystore.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Store</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_payment.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Player</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_team.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Team</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/logout.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Logout</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="left_panel add_product_panel">
                                <div class="row checkout_wizard">
                                    <div class="col-xl-3 col-lg-3">
                                        <h2
                                            class="font_size_20 font-weight-bold mb-0 text_black"
                                        >
                                            Add Product
                                        </h2>
                                    </div>
                                    <div class="col-xl-6 col-lg-9">
                                        <div
                                            class="wizard d-flex justify-content-lg-center align-items-center"
                                        >
                                            <div
                                                class="field d-flex justify-content-center align-items-center"
                                            >
                                                <div
                                                    class="circle mr_10 d-none"
                                                >
                                                    1
                                                </div>
                                                <div
                                                    class="circle mr_10 bg_primary_blue"
                                                >
                                                    <img
                                                        src="/maincss/images/icons/right_tick.svg"
                                                    />
                                                </div>
                                                <h5 class="mb-0">
                                                    Store Details
                                                </h5>
                                            </div>
                                            <div class="devider"></div>
                                            <div
                                                class="field d-flex justify-content-center align-items-center"
                                            >
                                                <div class="circle mr_10">
                                                    2
                                                </div>
                                                <h5 class="mb-0">
                                                    Add Products
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="add_product_box mt_66 pt_40 px_30 pb_14"
                                >
                                    <div class="row mt_30 custom_cat_row">
                                        <div class="col-md-6 col-lg-4 col-xl-5">
                                            <div class="form-group mt_0">
                                                <label>Select Category</label
                                                ><span class="highlight"></span
                                                ><select
                                                    class="form-control bg-transparent"
                                                >
                                                    <option>Bags</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-xl-5">
                                            <div class="form-group mt_0">
                                                <label
                                                    >Select Sub Category</label
                                                ><span class="highlight"></span
                                                ><select
                                                    class="form-control bg-transparent"
                                                >
                                                    <option>
                                                        Cotton Drawstring Bag
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 col-lg-4 col-xl-2"
                                        >
                                            <div
                                                class="zoomin_bin_wrap d-flex align-items-baseline"
                                            >
                                                <div class="zoomin">
                                                    <span class="font_size_14"
                                                        >4 Bags</span
                                                    ><span class="ml_10 mr_20"
                                                        ><a href="#"
                                                            ><img
                                                                alt=""
                                                                src="/maincss/images/icons/zoomin.svg" /></a
                                                    ></span>
                                                </div>
                                                <div class="bin_icon">
                                                    <span
                                                        ><a href="#"
                                                            ><img
                                                                alt=""
                                                                src="/maincss/images/icons/bin_red.svg" /></a
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt_30">
                                        <div
                                            class="col-lg-6 col-md-12 col-xl-3"
                                        >
                                            <div class="product mb_36">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex"
                                                    >
                                                        <a
                                                            href="/24hourtshirts"
                                                            class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                            ><img
                                                                src="/maincss/images/cart_icon.svg"
                                                                alt=" "
                                                                class="mr_16"
                                                            />
                                                            Add to cart</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="favorite_button bg_primary_orange py_18 px_18"
                                                            ><img
                                                                src="/maincss/images/favorite_delete.svg"
                                                                alt=" "
                                                        /></a>
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6 d-flex justify-content-center align-items-center"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_14"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_14"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="col-lg-6 col-md-12 col-xl-3"
                                        >
                                            <div class="product mb_36">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_primary_red font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex"
                                                    >
                                                        <a
                                                            href="/24hourtshirts"
                                                            class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                            ><img
                                                                src="/maincss/images/cart_icon.svg"
                                                                alt=" "
                                                                class="mr_16"
                                                            />
                                                            Add to cart</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="favorite_button bg_primary_orange py_18 px_18"
                                                            ><img
                                                                src="/maincss/images/favorite_delete.svg"
                                                                alt=" "
                                                        /></a>
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_14"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_14"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="col-lg-6 col-md-12 col-xl-3"
                                        >
                                            <div class="product mb_36">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex"
                                                    >
                                                        <a
                                                            href="/24hourtshirts"
                                                            class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                            ><img
                                                                src="/maincss/images/cart_icon.svg"
                                                                alt=" "
                                                                class="mr_16"
                                                            />
                                                            Add to cart</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="favorite_button bg_primary_orange py_18 px_18"
                                                            ><img
                                                                src="/maincss/images/favorite_delete.svg"
                                                                alt=" "
                                                        /></a>
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_14"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_14"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="col-lg-6 col-md-12 col-xl-3"
                                        >
                                            <div class="product mb_36">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex"
                                                    >
                                                        <a
                                                            href="/24hourtshirts"
                                                            class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                            ><img
                                                                src="/maincss/images/cart_icon.svg"
                                                                alt=" "
                                                                class="mr_16"
                                                            />
                                                            Add to cart</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="favorite_button bg_primary_orange py_18 px_18"
                                                            ><img
                                                                src="/maincss/images/favorite_delete.svg"
                                                                alt=" "
                                                        /></a>
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_14"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_14"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="add_product_box mt_66 pt_40 px_30 pb_14"
                                >
                                    <div class="row mt_30">
                                        <div class="col-md-6 col-lg-4 col-xl-5">
                                            <div class="form-group mt_0">
                                                <label>Select Category</label
                                                ><span class="highlight"></span
                                                ><select
                                                    class="form-control bg-transparent"
                                                >
                                                    <option>Bags</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4 col-xl-5">
                                            <div class="form-group mt_0">
                                                <label
                                                    >Select Sub Category</label
                                                ><span class="highlight"></span
                                                ><select
                                                    class="form-control bg-transparent"
                                                >
                                                    <option>
                                                        Cotton Drawstring Bag
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div
                                            class="col-md-12 col-lg-4 col-xl-2"
                                        >
                                            <div
                                                class="zoomin_bin_wrap d-flex align-items-baseline"
                                            >
                                                <div class="zoomin">
                                                    <span class="font_size_14"
                                                        >4 Bags</span
                                                    ><span class="ml_10 mr_20"
                                                        ><a href="#"
                                                            ><img
                                                                alt=""
                                                                src="/maincss/images/icons/zoomin.svg" /></a
                                                    ></span>
                                                </div>
                                                <div class="bin_icon">
                                                    <span
                                                        ><a href="#"
                                                            ><img
                                                                alt=""
                                                                src="/maincss/images/icons/bin_red.svg" /></a
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt_30">
                                        <div
                                            class="col-lg-6 col-md-12 col-xl-3"
                                        >
                                            <div class="product mb_36">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex"
                                                    >
                                                        <a
                                                            href="/24hourtshirts"
                                                            class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                            ><img
                                                                src="/maincss/images/cart_icon.svg"
                                                                alt=" "
                                                                class="mr_16"
                                                            />
                                                            Add to cart</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="favorite_button bg_primary_orange py_18 px_18"
                                                            ><img
                                                                src="/maincss/images/favorite_delete.svg"
                                                                alt=" "
                                                        /></a>
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6 d-flex justify-content-center align-items-center"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_14"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_14"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="col-lg-6 col-md-12 col-xl-3"
                                        >
                                            <div class="product mb_36">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_primary_red font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex"
                                                    >
                                                        <a
                                                            href="/24hourtshirts"
                                                            class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                            ><img
                                                                src="/maincss/images/cart_icon.svg"
                                                                alt=" "
                                                                class="mr_16"
                                                            />
                                                            Add to cart</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="favorite_button bg_primary_orange py_18 px_18"
                                                            ><img
                                                                src="/maincss/images/favorite_delete.svg"
                                                                alt=" "
                                                        /></a>
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_14"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_14"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="col-lg-6 col-md-12 col-xl-3"
                                        >
                                            <div class="product mb_36">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex"
                                                    >
                                                        <a
                                                            href="/24hourtshirts"
                                                            class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                            ><img
                                                                src="/maincss/images/cart_icon.svg"
                                                                alt=" "
                                                                class="mr_16"
                                                            />
                                                            Add to cart</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="favorite_button bg_primary_orange py_18 px_18"
                                                            ><img
                                                                src="/maincss/images/favorite_delete.svg"
                                                                alt=" "
                                                        /></a>
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_14"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_14"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="col-lg-6 col-md-12 col-xl-3"
                                        >
                                            <div class="product mb_36">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex"
                                                    >
                                                        <a
                                                            href="/24hourtshirts"
                                                            class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                                                            ><img
                                                                src="/maincss/images/cart_icon.svg"
                                                                alt=" "
                                                                class="mr_16"
                                                            />
                                                            Add to cart</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="favorite_button bg_primary_orange py_18 px_18"
                                                            ><img
                                                                src="/maincss/images/favorite_delete.svg"
                                                                alt=" "
                                                        /></a>
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_14"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_14"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12 text-center mt_60">
                                        <a href="#"
                                            ><span class="ml-auto my-auto plus"
                                                ><img
                                                    src="/maincss/images/plus.svg"
                                                    alt=" " /></span
                                            ><span
                                                class="add_cat font_size_18 text_primary_blue ml_14 pt_2"
                                                >Add Other Category</span
                                            ></a
                                        >
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div
                                            class="add_product_btns buttons ml-auto text-center text-lg-right"
                                        >
                                            <a
                                                href="#"
                                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_22 px_80 mr_34"
                                                >Cancel</a
                                            ><a
                                                href="#"
                                                class="btn-desable btn btn_orange bg_primary_orange text_white py_22 px_80"
                                                >ADD</a
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "AddProductCatagory",
    components: {},
    mounted() {
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
    }
};
</script>
